import { render, staticRenderFns } from "./ConceptView.vue?vue&type=template&id=21ec9c36&scoped=true&"
import script from "./ConceptView.vue?vue&type=script&lang=ts&"
export * from "./ConceptView.vue?vue&type=script&lang=ts&"
import style0 from "./ConceptView.vue?vue&type=style&index=0&id=21ec9c36&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ec9c36",
  null
  
)

export default component.exports